import { render } from "./CriterionItem.vue?vue&type=template&id=002b0222"
import script from "./CriterionItem.vue?vue&type=script&lang=js"
export * from "./CriterionItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__